<template>
  <span class="worker-risk" @click.stop @dblclick.stop>
    <span :class="['custom-tag', variant]">{{ label }}</span>
    <button
      v-if="isSmz"
      :id="tooltipId"
      type="button"
      class="risk-help ml-1"
      aria-label="Описание рисков исполнителя"
    >?</button>
    <b-tooltip v-if="isSmz" :target="tooltipId" noninteractive triggers="hover focus" placement="auto">
      <div v-for="(description, index) in descriptions" :key="index" class="text-left mb-1">{{ description }}</div>
    </b-tooltip>
  </span>
</template>

<script>
export default {
  name: 'WorkerRisk',
  props: {
    employmentType: { default: null },
    risk: { type: Object, default: null },
  },
  computed: {
    isSmz() { return Number(this.employmentType) === 1; },
    tooltipId() { return `worker-risk-${this._uid}`; },
    level() { return this.isSmz ? (this.risk ? this.risk.level : 'loading') : 'low'; },
    label() {
      return { low: 'Низкий', high: 'Высокий', violation: 'Нарушение закона', unknown: 'Нет данных', loading: 'Загрузка…' }[this.level];
    },
    variant() {
      return { low: 'tag-success', high: 'tag-warning', violation: 'tag-danger' }[this.level] || 'text-secondary';
    },
    descriptions() {
      if (!this.risk) return ['Загружаем риски из Баланс Про.'];
      return this.risk.descriptions && this.risk.descriptions.length
        ? this.risk.descriptions
        : ['Показатели риска не сработали. Доля дохода: высокий риск — выше 70%, нарушение закона — выше 80%. Продолжительность работ: высокий риск — больше 75 дней, нарушение закона — больше 90 дней.'];
    },
  },
};
</script>

<style scoped>
.worker-risk { white-space: nowrap; }
.risk-help { border: 1px solid currentColor; border-radius: 50%; background: transparent; color: #6c757d; width: 20px; height: 20px; padding: 0; line-height: 18px; cursor: help; }
</style>



// WEBPACK FOOTER //
// src/components/Workers/WorkerRisk.vue